import { render, staticRenderFns } from "./ThemeCustomizerModal.vue?vue&type=template&id=16f49bf7&"
import script from "./ThemeCustomizerModal.vue?vue&type=script&lang=js&"
export * from "./ThemeCustomizerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16f49bf7')) {
      api.createRecord('16f49bf7', component.options)
    } else {
      api.reload('16f49bf7', component.options)
    }
    module.hot.accept("./ThemeCustomizerModal.vue?vue&type=template&id=16f49bf7&", function () {
      api.rerender('16f49bf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/theme/components/ThemeCustomizerModal.vue"
export default component.exports